export const APP_TIMEZONE = 'Australia/Sydney';

export const normaliseApiDate = (value) => {
  if (!value) return null;
  if (value instanceof Date) return value;

  const str = String(value);

  if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/.test(str) && !/[zZ]|[+-]\d{2}:\d{2}$/.test(str)) {
    return new Date(`${str}Z`);
  }

  return new Date(str);
};

export const formatSydneyDate = (value) => {
  const d = normaliseApiDate(value);
  if (!d || isNaN(d.getTime())) return '-';

  return d.toLocaleDateString('en-AU', {
    timeZone: APP_TIMEZONE,
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
};

export const formatSydneyTime = (value, withSeconds = false) => {
  const d = normaliseApiDate(value);
  if (!d || isNaN(d.getTime())) return '-';

  return d.toLocaleTimeString('en-AU', {
    timeZone: APP_TIMEZONE,
    hour: '2-digit',
    minute: '2-digit',
    second: withSeconds ? '2-digit' : undefined,
    hour12: false,
  });
};

export const formatSydneyDateTime = (value, withSeconds = false) => {
  const d = normaliseApiDate(value);
  if (!d || isNaN(d.getTime())) return '-';

  return d.toLocaleString('en-AU', {
    timeZone: APP_TIMEZONE,
    weekday: 'long',
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: withSeconds ? '2-digit' : undefined,
    hour12: false,
  });
};
